import axios from "axios";

const updatePinRequiredStatus = (id, pinRequired) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/serialnumber/api/v1/generate/status/pin-required/update/${id}`, { pin_required: pinRequired })
      .then((response) => resolve({ ...response.data, id, pinRequired }))
      .catch((error) => {
        reject(error.response?.data || error);
      });
  });
};

export default updatePinRequiredStatus;